import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-coach-dashboard" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "app-coach-dashboard-calendar" }
const _hoisted_4 = { class: "wrapper-profile" }
const _hoisted_5 = { class: "section-default" }
const _hoisted_6 = { class: "headline" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Kalendar ", -1)
const _hoisted_8 = { class: "action" }
const _hoisted_9 = { class: "calendar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoachNavigationVue = _resolveComponent("CoachNavigationVue")!
  const _component_CoachDashboardNavigationVue = _resolveComponent("CoachDashboardNavigationVue")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_AppCoachDashboardRootUserInformationIndexVue = _resolveComponent("AppCoachDashboardRootUserInformationIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CoachNavigationVue),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CoachDashboardNavigationVue),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "el-button--primary el-button--square",
                  onClick: _ctx.prevMonth
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "el-button--primary el-button--square",
                  onClick: _ctx.nextMonth
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowRight)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_el_row, {
              gutter: 16,
              type: "flex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 24,
                  xl: 24
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_FullCalendar, {
                        ref: "Calendar",
                        options: _ctx.calendarOptions
                      }, null, 8, ["options"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_AppCoachDashboardRootUserInformationIndexVue)
        ])
      ])
    ])
  ]))
}